/**
 * Build-/Versionsinformationen des laufenden Frontends.
 *
 * Die REACT_APP_*-Werte werden beim Image-Build eingebrannt (frontend/Dockerfile,
 * _build-and-push.yml). Lokal ohne Build gilt "dev". Der Backend-Stand kommt
 * zur Laufzeit aus /api/health (gleiche Struktur, siehe backend/app/version.py).
 */

export interface BuildInfo {
  git_sha: string;
  git_sha_short: string;
  git_branch: string | null;
  build_time: string | null;
  image_tag: string | null;
}

type Env = Record<string, string | undefined>;

const leerAlsNull = (wert: string | undefined): string | null => {
  const v = (wert ?? '').trim();
  return v.length > 0 ? v : null;
};

export function buildInfoAusEnv(env: Env): BuildInfo {
  const sha = leerAlsNull(env.REACT_APP_GIT_SHA) ?? 'dev';
  return {
    git_sha: sha,
    git_sha_short: sha.slice(0, 7),
    git_branch: leerAlsNull(env.REACT_APP_GIT_BRANCH),
    build_time: leerAlsNull(env.REACT_APP_BUILD_TIME),
    image_tag: leerAlsNull(env.REACT_APP_IMAGE_TAG),
  };
}

/** CRA ersetzt process.env.REACT_APP_* nur bei direktem Zugriff – daher explizit. */
export const FRONTEND_BUILD: BuildInfo = buildInfoAusEnv({
  REACT_APP_GIT_SHA: process.env.REACT_APP_GIT_SHA,
  REACT_APP_GIT_BRANCH: process.env.REACT_APP_GIT_BRANCH,
  REACT_APP_BUILD_TIME: process.env.REACT_APP_BUILD_TIME,
  REACT_APP_IMAGE_TAG: process.env.REACT_APP_IMAGE_TAG,
});

export function formatVersion(info: BuildInfo): string {
  if (!info.build_time) return info.git_sha_short;
  const d = new Date(info.build_time);
  if (Number.isNaN(d.getTime())) return info.git_sha_short;
  const tt = String(d.getUTCDate()).padStart(2, '0');
  const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
  return `${info.git_sha_short} · ${tt}.${mm}.${d.getUTCFullYear()}`;
}

/** Frontend und Backend aus verschiedenen Commits – z.B. halb durchgelaufenes Deploy. */
export function versionsAbweichung(frontendSha: string, backendSha: string): boolean {
  if (frontendSha === 'dev' || backendSha === 'dev') return false;
  return frontendSha !== backendSha;
}
